import { useAuth } from '../auth/AuthContext.js';

/**
 * The Rewards tracker (grades → classes → GAMES) is a private tool for the
 * computer-class teacher. Only these sign-in emails see the live "Rewards" tab
 * and its Settings tab. dev@classy.local is included for local dev-auth only.
 */
const REWARDS_EMAILS = new Set(['sarah@sm2gk.com', 's@sm2gk.com', 'dev@classy.local']);

export function canUseRewards(email: string | undefined | null): boolean {
  if (!email) return false;
  return REWARDS_EMAILS.has(email.trim().toLowerCase());
}

/** True when the signed-in teacher may use the Rewards tracker. */
export function useRewardsAccess(): boolean {
  const auth = useAuth();
  return canUseRewards(auth.account?.email);
}
